module.exports = __webpack_public_path__ + "img/a.d036a2ee.jpg";